import React from "react";
import { useNavigate, useParams  } from "react-router-dom";
import { AdminModal } from "../../../components";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import {
	FormDropdownField,
} from "../../../components/custom_form_component/CustomFormComponent";
import { useSelector, useDispatch } from "react-redux";
import { LoadingBar } from "../../../components/loading_bar/LoadingBar";
import { changeStatus, reset } from "../../../features/admin/adminSlice";
import {
	DetailsBody,
	DetailsFooter,
	DetailsHeader,
	DetailsHeaderDesc,
	DetailsPanelStyled,
} from "../../../styles/admin/DetailsPanel";
import { PanelForm, PanelRow } from "../../../styles/admin/Forms.styled";
import { FormPanelButton } from "../../../styles/FormPanel.Styled";

const formDefaults = {
	status: "",
};

const statusOptions = [
	{ label: "Active", value: "active" },
	{ label: "Pending", value: "pending" },
	{ label: "Deactivate", value: "deactivated" },
];

function ChangeTeamMemberStatus() {
	const navigate = useNavigate();
    const { email } = useParams()
	const handleClose = () => {
		navigate(-1);
	};

	const {
		handleSubmit,
		control,
		reset: resetForm,
		formState: { errors },
	} = useForm({
		defaultValues: formDefaults,
	});

	const dispatch = useDispatch();
	const ref = React.useRef(null);

	const { data, isError, isSuccess, isLoading, message } =
		useSelector((state) => state.admin);

	React.useEffect(() => {
		if (isError) {
			toast.error(message);
			ref.current.complete();
		}

        if(isSuccess){
            ref.current.complete();
        }

		if (isSuccess && message) {
			toast.success(message);
			resetForm(formDefaults);
		}

		dispatch(reset());
	}, [data, isError, isSuccess, message, resetForm, dispatch]);
	const onSubmit = (data) => {
		if (!isLoading) {
			ref.current.continuousStart();
			dispatch(changeStatus({email: email, data: data}));
		}
	};

	return (
		<>
			<AdminModal open={true} onClose={handleClose}>
				<LoadingBar ref={ref} shadow={true} />
				<DetailsPanelStyled as="form" onSubmit={handleSubmit(onSubmit)}>
					<DetailsHeader>
						<DetailsHeaderDesc>
							<h3>Change Status</h3>
						</DetailsHeaderDesc>
					</DetailsHeader>
					<DetailsBody padding="2rem">
						<PanelForm>
							<PanelRow>
								<FormDropdownField
									name="status"
									label="Status"
									options={statusOptions}
									control={control}
									placeholder="Choose Status"
									rules={{
										required: {
											value: "required",
											message: "Please select a status",
										},
									}}
									errors={errors}
								/>
							</PanelRow>
						</PanelForm>
					</DetailsBody>
					<DetailsFooter>
						<div></div>
						<div>
							<FormPanelButton type="submit" primary>
								Change Account Status
							</FormPanelButton>
						</div>
					</DetailsFooter>
				</DetailsPanelStyled>
			</AdminModal>
		</>
	);
}

export default ChangeTeamMemberStatus;
